module.exports = __webpack_public_path__ + "static/media/arrow-left.4136d154.svg";